import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: {url?: string};
}

@Component({
    selector: 'tiktok-widget-modal',
    templateUrl: './tiktok-widget-modal.component.html',
    styleUrls: ['./tiktok-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TiktokWidgetModalComponent {
    static type = 'tiktokEmbed';
    errors$ = new BehaviorSubject<{url?: string}>({});
    form = new FormGroup({
        url: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<TiktokWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService
    ) {
        if (data.config?.url) {
            this.form.patchValue({url: data.config?.url});
        }
    }

    createOrUpdate() {
        if (!this.form.value.url.includes('tiktok.com/')) {
            return this.errors$.next({url: 'This is not a valid tiktok url.'});
        }
        this.editor
            .crupdateWidget(
                this.data.widgetId,
                TiktokWidgetModalComponent.type,
                this.form.value
            )
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
